import Vue from "vue";
import sessionIdDirective from "../directive/sessionId-directive";
import initService from "./init-service";
const QRCodeLib = require("qrcode");

let baseurl = `${process.env.VUE_APP_CONFIG_ESIM_BASEURL}`;
let apikey = `${process.env.VUE_APP_CONFIG_APIKEY}`;

let userName = initService.getUserNameInfo();
let customer = initService.getCustomerInfo();
let group = initService.getGroupInfo();
let pId = sessionIdDirective.getJSessionId();
let headers = {
    headers: {
        "Content-Type": "application/json",
        "x-api-key": apikey,
    },
};

const eSimDashboardService = {

    async getProfileStats(profileType) {
        let url = `${baseurl}?method=esim_getprofilestats&profileType=${profileType}&customer=${customer}&user=${userName}&group=${group}&pid=${pId}`;
        return Vue.axios.get(url, headers);
    },

    async getProfileType(profileTypeId) {
        let result = [];
        await this.getProfileTypes().then(json => {
            //console.log(json)
            json.data.profileTypes.forEach(item => {
                if (item.profileTypeId.toString() === profileTypeId.toString()) {
                    //console.log('FOUND:',item.profileType);
                    result = item;
                    return;
                }
            });
        });
        return Promise.resolve(result);
    },

    async getProfileTypes() {
        let url = `${baseurl}?method=esim_getprofiletypes&customer=${customer}&user=${userName}&group=${group}&pid=${pId}`;
        return Vue.axios.get(url, headers);
    },

    async getProfileTransitions(iccid) {
        let url = `${baseurl}?method=esim_getprofiletransitions&iccid=${iccid}&customer=${customer}&user=${userName}&group=${group}&pid=${pId}`;
        return Vue.axios.get(url, headers);
    },

    async esimGetprofileinstallerrors(iccid) {
        let url = `${baseurl}?method=esim_getprofileinstallerrors&startDate=2022-01-01&endDate=2023-01-01&iccid=${iccid}`;
        return Vue.axios.get(url, headers);
    },

    async getEidInfo(eid) {
        let url = `${baseurl}?method=esim_geteidinfo&eid=${eid}`;
        return Vue.axios.get(url, headers);
    },

    async getInventoryAdvanced(sort, range, filter) {
        //method=esim_getInventoryAdvanced&sort=["iccid","asc"]&range=[0,14]&filter={"iccid":"89010701910000001201"}
        let url = `${baseurl}?method=esim_getInventoryAdvanced`;
        if (sort) url += "&sort=" + encodeURI(sort);
        if (range) url += "&range=" + encodeURI(range);
        if (filter) url += "&filter=" + encodeURI(filter);
        return Vue.axios.get(url, headers);
    },

    async inventory(filter) {
        //console.log(filter);
        let url = `${baseurl}?method=esim_getinventory`;
        if (filter) url += "&filter=" + encodeURI(filter);
        // if (carrier) url+=`&carrier=${carrier}`;
        // if (sim_type) url+=`&sim_type=${sim_type}`;
        // if (page) url+=`&page=${page}`;
        // if (sort) url+=`&sort=${sort}`;
        // if (enabled) url+=`&enabled=${enabled}`;
        // if (search) url+=`&search=${search}`;
        return Vue.axios.get(url, headers);
    },

    async getInventory(filter, carrier) {
        let url = "";
        if (!carrier || carrier === "undefined") carrier = "";
        // if (eid && eid.length > 0) url = `${baseurl}?method=esim_geteidinfo&eid=${filter}&customer=${customer}&user=${userName}&group=${group}&pid=${pId}`;
        // else url = `${baseurl}?method=esim_getinventory&customer=${customer}&user=${userName}&group=${group}&pid=${pId}`;
        url = `${baseurl}?method=esim_getinventory&filter=${filter}&carrier=${carrier}&customer=${customer}&user=${userName}&group=${group}&pid=${pId}`;
        return Vue.axios.get(url, headers);
    },

    async getInventoryByType(profileType) {
        let result = [];
        await this.getInventory().then(json => {
            json.forEach(item => {
                if (item.profileType.toString() === profileType.toString()) {
                    //console.log('FOUND:',item.profileType);
                    result = item;
                    return;
                }
            });
        });
        return Promise.resolve(result);
    },

    async getProfile(iccid) {
        let url = `${baseurl}?method=esim_getprofileinfo&iccid=${iccid}&customer=${customer}&user=${userName}&group=${group}&pid=${pId}`;
        return Vue.axios.get(url, headers);
    },

    async esim_activate(iccid, eid, profileType, matchingId, confirmationCode, device_type, qrcode){

        let url = `${baseurl}?method=esim_activate&iccid=${iccid}`;
        if (eid!=='' ) url +=`&eid=${eid}`;
        if (profileType!=='')  url +=`&profileType=${profileType}`;
        if (matchingId!=='')  url +=`&matchingId=${matchingId}`;
        if (confirmationCode!=='')  url +=`&confirmationCode=${confirmationCode}`;
        if (device_type!=='')  url +=`&device_type=${device_type}`;
        if (qrcode!=='')  url +=`&qrcode=${qrcode}`;
        //console.log(url);
        return Vue.axios.get(url, headers);

    },

    async downloadConfirmOrder(iccid, eid, profileType, matchingId, confirmationCode, smdpAddress) {
        //method=downloadConfirmOrder&iccid=${iccid}&eid=${eid}r&profileType=${profileType&matchingId=${matchingId}&confirmationCode=${confirmationCode}&customer=${customer}&user=${userName}&group=${group}&pid=${pId}
        //let url = `${baseurl}?method=downloadConfirmOrder&iccid=${iccid}&eid=${eid}r&profileType=${profileType}&matchingId=${matchingId}&confirmationCode=${confirmationCode}&customer=${customer}&user=${userName}&group=${group}&pid=${pId}`;
        let url = `${baseurl}?method=esim_downloadconfirmorder&iccid=${iccid}&eid=${eid}&profileType=${profileType}&matchingId=${matchingId}&confirmationCode=${confirmationCode}&smdsAddress=${smdpAddress}&customer=${customer}&user=${userName}&group=${group}&pid=${pId}`;
        //console.log(url);
        return Vue.axios.get(url, headers);
    },

    async downloadOrder(profileType, iccid) {
        //method=downloadConfirmOrder&iccid=${iccid}&eid=${eid}&matchingId=${matchingId}&confirmationCode=${confirmationCode}&customer=${customer}&user=${userName}&group=${group}&pid=${pId}
        let url = `${baseurl}?method=esim_downloadorder&profileType=${profileType}&iccid=${iccid}&customer=${customer}&user=${userName}&group=${group}&pid=${pId}`;
        //console.log(url);
        return Vue.axios.get(url, headers);
    },

    async confirmOrder(iccid) {
        //method=confirmOrder&iccid=${iccid}&eid=${eid}&matchingId=${matchingId}&confirmationCode=${confirmationCode}&customer=${customer}&user=${userName}&group=${group}&pid=${pId}
        let url = `${baseurl}?method=esim_confirmorder&profileType=${iccid}&customer=${customer}&user=${userName}&group=${group}&pid=${pId}`;
        return Vue.axios.get(url, headers);
    },

    async cancelOrder(iccid, eid, matchingId, finalProfileStatusIndicator) {
        //method=cancelOrder&iccid=${iccid}&eid=${eid}&matchingId=${matchingId}&finalProfileStatusIndicator=${finalProfileStatusIndicator}
        let url = `${baseurl}?method=esim_cancelorder&iccid=${iccid}&eid=${eid}&matchingId=${matchingId}&finalProfileStatusIndicator=${finalProfileStatusIndicator}&customer=${customer}&user=${userName}&group=${group}&pid=${pId}`;
        //console.log(url);
        return Vue.axios.get(url, headers);
    },

    async releaseProfile(iccid) {
        //method=releaseProfile&iccid=${iccid}&eid=${eid}&matchingId=${matchingId}&finalProfileStatusIndicator=${finalProfileStatusIndicator}
        let url = `${baseurl}?method=esim_releaseprofile&iccid=${iccid}&customer=${customer}&user=${userName}&group=${group}&pid=${pId}`;
        return Vue.axios.get(url, headers);
    },

    async getQrimage(data) {
        await QRCodeLib.toDataURL(data, function (err, url) {
            return url;
        });
    },

    async getActivationImage(smdp, activation) {
        await QRCodeLib.toDataURL(
            "LPA:1$" + profileData.smdpAddress + "$" + profileData.matchingId,
            function (err, url) {
                return url;
            }
        );
    },

    //TODO: validate getActivityDetail
    async getActivityDetail(id) {
        let i = [];
        await this.getActivity().then(json => {
            json.results.forEach(item => {
                if (item.event_timestamp === id) {
                    i = item;
                    return;
                }
            });
        });
        return i;
    },

    //TODO: validate getActivity
    async getActivity(iccid) {
        //{{dev-uri}}?method=getProfileTransitions&iccid=89012901700000000001&startDate=2021-01-01&endDate=2025-01-01
        let data = {};
        return Promise.resolve(data);
    },

    //TODO: validate getBlacklistId
    async getBlacklistId(iccid) {
        // '{"values":["89049032006008882600101475521386"],"type":"eid","list-type":"blacklist"}'
        let data = [
            {
                id: "18808",
            },
        ];
        return data;
    },

    //TODO: validate getBlacklistedList
    async getBlacklistedList() {
        let data = [
            {
                target: "mno_euicc_blacklist",
                type: "eid",
                value: "89049032006008882600101475521386",
                scope: "requester",
                value_id: "18808",
                "profile-type": "",
                "list-type": "blacklist",
            },
            {
                target: "mno_euicc_blacklist",
                type: "eid",
                value: "89049032006008882600101475529999",
                scope: "requester",
                value_id: "18809",
                "profile-type": "",
                "list-type": "blacklist",
            },
        ];
        return data;
    },

    //TODO: validate addBlacklist
    async addBlacklist(iccid) {
        let data = [
            {
                id: "18815",
            },
        ];
        return data;
    },

    //TODO: validate delBlacklist
    async delBlacklist(id) {
        //do remove
        return true;
    },

    getProfileLists(profileTypes = []) {
        if (!profileTypes.length) return;

        function fetchProfileType(profileType) {
            const url = `${baseurl}?method=esim_getprofilestats&profileType=${profileType}`;
            return Vue.axios.get(url, headers)
        }
        const promises = profileTypes.map(profile => fetchProfileType(profile.profileType));

        return Promise.all(promises)
            .then(results => {
                // Process the results array containing the data returned from the API
                return results.map(res => {
                    const { data: { inventoryStats } } = res;
                    return { profileType: inventoryStats[0].profileType, ...inventoryStats[0].statusesCount };
                });
            })
            .catch(error => {
                console.error("Error:", error);
            });

    },

    getStateClass(state) {
        // Status	Description
        // Available	The Profile is available in the inventory of the SM-DP+.
        // Allocated	The Profile is reserved for downloading without being linked to an EID.
        // Linked	The Profile is reserved for downloading and is linked to an EID.
        // Confirmed	The Profile is reserved for downloading (linked or not linked to an EID) with Matching ID and Confirmation Code if required.
        // Released	The Profile is ready for download and installation after Network Configuration by the Operator (e.g.: HLR Registration).
        // Downloaded	The Bound Profile was delivered to the LPA.
        // Installed	The Profile was successfully installed on the eUICC.
        // Error	The Profile has not been installed because of one of the following error cases:
        // - Confirmation Code Retry Limit exceeded
        // - Download Retry Limit exceeded
        // - End User Rejection
        // - Error during download and installation
        // Unavailable	The Profile cannot be reused anymore by the SM-DP+.

        let sstate = `${state}`; //convert to string
        sstate = sstate.toLowerCase();
        let sclass = "";
        if (sstate === "ok" || sstate === "success" || sstate === "available" || sstate === "linked") {
            sclass = "success";
        } else if (sstate === "failed" || sstate === "danger" || sstate === "cancel" || sstate === "error") {
            sclass = "danger";
        } else if (sstate === "info" || sstate === "released" || sstate === "downloaded") {
            sclass = "info";
        } else if (sstate === "primary" || sstate === "installed") {
            sclass = "primary";
        } else if (sstate === "warning" || sstate === "allocated") {
            sclass = "warning";
        } else {
            sclass = "";
        }
        //colors available
        // 'default',
        //   'info',
        //   'primary',
        //   'danger',
        //   'warning',
        //   'success'
        //console.log('getStateClass[state][class]', sstate, sclass);
        return sclass;
    },

    formatVariables(encoded) {
        let url = `${baseurl}?method=esim_formatVariables&variables=${encoded}`;
        return Vue.axios.get(url, headers);
    },

    bumpProfile(iccid, id) {
        let url = `${baseurl}?method=esim_bumpProfile&profileTypeId=${id}&iccid=${iccid}`;
        return Vue.axios.get(url, headers);
    },

    addSimToProfile(encoded, id) {
        let url = `${baseurl}?method=esim_addSimToProfile&profileTypeId=${id}&variables=${encoded}`;
        return Vue.axios.get(url, headers);
    },

    /**
     * Create or Update the standard carrier profile based upon carrier template
     * @param profileTypeId
     * @param profileType
     * @param mccmnc
     * @returns {Promise<AxiosResponse<any>>}
     */
    createCarrierProfile(profileTypeId, profileType, mccmnc) {
        let url = `${baseurl}?method=esim_createCarrierProfile&profileTypeId=${profileTypeId}&profileType=${profileType}&mccmnc=${mccmnc}`;
        return Vue.axios.get(url, headers);
    },

    getESimTemplateVarialbe() {
        let url = `${baseurl}?method=esim_getTemplatevariables&filter=ALL`;
        return Vue.axios.get(url, headers)
    },

    getParentTemplate(query) {
        let url = `${baseurl}?method=esim_getTemplatevariables&filter=ALL&profileType=${query}`;
        return Vue.axios.get(url, headers)
    },

    pushCarrierTemplate(profileType) {
        let url = `${baseurl}?method=esim_pushCarrierTemplate&profileType=${profileType}`;
        return Vue.axios.get(url, headers)
    },

    saveCarrierTemplate(param) {
        let url = `${baseurl}?method=esim_saveCarrierTemplate`;
        return Vue.axios.post(url, param, headers)
    }
};

export default eSimDashboardService;
